import { takeEvery, put, call } from 'redux-saga/effects'

import axios from 'portal/utils/axios-msal'
import * as actions from './actions'

function* accountConnectionsSummaryLoadSaga(action) {
  if (action.accountId === '' || action.accountId === null) {
    yield put(
      actions.accountConnectionsSummaryLoadFailure('No Account Id was set')
    )
  }
  try {
    const response = yield call(
      axios.get,
      '/accounts/' + action.accountId + '/project-connections'
    )
    const data = response.data
    yield put(actions.accountConnectionsSummaryLoaded(data))
  } catch (error) {
    yield put(actions.accountConnectionsSummaryLoadFailure(error))
  }
}

export function* watch() {
  yield takeEvery(
    actions.ACC_CONN_SUMMARY_LOAD_SAGA,
    accountConnectionsSummaryLoadSaga
  )
}
